/** 샵관리 리포트 화면(월손익·대시보드) 공통 표현 요소 */
import React from 'react';
import styled from 'styled-components';
import { fmt } from 'shop/shopStore';

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  margin: 6px 0;
`;

const CardBox = styled.div`
  border: 1px solid #d9dde3;
  border-radius: 4px;
  padding: 8px 10px;
  background: #fff;
  .l { font-size: 12px; color: #5b6472; }
  .v { font-size: ${(p) => (p.$strong ? '20px' : '17px')}; font-weight: 700; margin-top: 2px; color: ${(p) => (p.$neg ? '#c0392b' : '#1f2933')}; }
  .s { font-size: 11px; color: #8792a2; margin-top: 2px; }
`;

export const Card = ({ label, value, sub, strong, negative, suffix = '원' }) => (
  <CardBox $strong={strong} $neg={negative}>
    <div className="l">{label}</div>
    <div className="v">{fmt(value)}{suffix}</div>
    {sub ? <div className="s">{sub}</div> : null}
  </CardBox>
);

const T = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: #fff;
  th, td { border: 1px solid #d9dde3; padding: 4px 8px; }
  th { background: #f3f5f8; text-align: center; }
  td.n { text-align: right; font-variant-numeric: tabular-nums; }
  tr.strong td { font-weight: 700; background: #fafbfc; }
`;

/** rows: [label, amount(number)|string, note] — 금액이 문자열이면 그대로 표시 */
export const Table = ({ head, rows, strongRows = [] }) => (
  <T>
    <thead>
      <tr>{head.map((h) => <th key={h}>{h}</th>)}</tr>
    </thead>
    <tbody>
      {rows.map((r, i) => (
        <tr key={`${r[0]}-${i}`} className={strongRows.includes(i) ? 'strong' : ''}>
          {r.map((c, j) => (
            <td key={j} className={typeof c === 'number' ? 'n' : ''}>{typeof c === 'number' ? fmt(c) : c}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </T>
);

export const MonthBar = ({ ym, setYm }) => {
  const shift = (d) => {
    const y = Number(ym.slice(0, 4));
    const m = Number(ym.slice(4)) - 1 + d;
    const dt = new Date(y, m, 1);
    setYm(`${dt.getFullYear()}${String(dt.getMonth() + 1).padStart(2, '0')}`);
  };
  const ok = /^\d{6}$/.test(ym);
  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center', margin: '4px 0', fontSize: 12 }}>
      <span>귀속월</span>
      <button type="button" disabled={!ok} onClick={() => shift(-1)} style={{ minHeight: 26, padding: '3px 8px' }}>◀</button>
      <input value={ym} onChange={(e) => setYm(e.target.value.replace(/\D/g, '').slice(0, 6))} style={{ width: 80, height: 24, textAlign: 'center' }} placeholder="YYYYMM" />
      <button type="button" disabled={!ok} onClick={() => shift(1)} style={{ minHeight: 26, padding: '3px 8px' }}>▶</button>
    </div>
  );
};
